export * from './build-details.component';
